import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UserUpdateCard from 'components/payments/UserUpdateCard';

function mapStateToProps(state) {
  return {
    updateCardStatus: state.paymentReducer.get('updateCardStatus')
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserUpdateCard);


// WEBPACK FOOTER //
// ./src/containers/UserUpdateCardContainer.js